import React from 'react';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';
import WorkersList from './workers';
import Tabs from '../../components/tabs';
import messages from '../../text/messages';

class PositionsPage extends React.Component {
    getTabs() {
        return [
            {
                title: <FormattedMessage {...messages.active} />,
                content: <WorkersList status="active" key="workersActive" />
            },
            {
                title: <FormattedMessage {...messages.inactive} />,
                content: <WorkersList status="inactive" key="workersInactive" />
            }
        ];
    }

    render() {
        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <Tabs items={this.getTabs()} pageWide title="Workers" isPageTitle={true} />
                    </div>
                </div>
            </div>
        );
    }
}

PositionsPage.meta = {
    label: <FormattedMessage {...messages.workers} />,
    icon: 'work',
    action: () => history.push('/positions'),
    locations: ['/positions']
};

export default PositionsPage;



// WEBPACK FOOTER //
// ./src/pages/positions/index.jsx